import React, {Component} from 'react';
import PropTypes from "prop-types";
import moment from "moment/moment";

class ExpireWarningHandle extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        warningStartDays: PropTypes.number.isRequired
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    renderCaseUserValidIsRunningOut(daysLeft = null) {

        if (daysLeft === null) return null;

        let header = this.translate('userValidIsRunningOutHeader1');

        if (daysLeft > 1) header = this.translate('userValidIsRunningOutHeader2').replace('__DAYS__', daysLeft);

        return (
            <div className="warningBox warningBlock">
                <p style={{marginBottom: 0}}>{header} {this.translate('userValidIsRunningOutText')}</p>
            </div>
        );

    }

    renderCaseCompanyLicenseIsRunningOut(daysLeft = null) {

        if (daysLeft === null) return null;

        let header = this.translate('companyLicenceIsRunningOutHeader1');

        if (daysLeft > 1) header = this.translate('companyLicenceIsRunningOutHeader2').replace('__DAYS__', daysLeft);

        const text = this.translate('companyLicenceIsRunningOutText');

        return (
            <div className="warningBox warningBlock">
                <p style={{marginBottom: 0}}>
                    {header} {text} <a href="https://shop.zsk.de" target="_blank">{this.translate('linkToShop')}</a>
                </p>
            </div>
        );

    }

    render() {

        if (!this.props.baseData || this.props.warningStartDays == null) return null;

        const now = new Date().getTime();

        const userValidUntil = this.props.baseData.userData.valid_until;
        const userValidDaysLeft =  Math.ceil(moment.duration(userValidUntil - now).asDays());

        const userCompanyLicenedTill = (this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany.date_licenced : null;
        const userCompanyLicenedDaysLeft =  (userCompanyLicenedTill) ? Math.ceil(moment.duration(userCompanyLicenedTill - now).asDays()) : null;

        let renderCase = null;

        if (userValidDaysLeft <= this.props.warningStartDays) {
            renderCase = this.renderCaseUserValidIsRunningOut(userValidDaysLeft);
        } else if (userCompanyLicenedDaysLeft && userCompanyLicenedDaysLeft <= this.props.warningStartDays) {
            renderCase = this.renderCaseCompanyLicenseIsRunningOut(userCompanyLicenedDaysLeft);
        }

        return renderCase;

    }

}

export default ExpireWarningHandle;